import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

// Keep this separate from the AdminDashboard welcome tour flag,
// so showing helpdesk tour won't affect dashboard tour.
export async function getHelpdeskTourSeen(db, companyId) {
  if (!companyId) return true; // fail-safe: don't auto-open
  const ref = doc(db, "companies", companyId, "onboarding", "helpdeskTour");
  const snap = await getDoc(ref);
  return snap.exists() ? !!snap.data()?.seen : false;
}

export async function setHelpdeskTourSeen(db, companyId, payload = {}) {
  if (!companyId) return;
  const ref = doc(db, "companies", companyId, "onboarding", "helpdeskTour");
  await setDoc(
    ref,
    {
      seen: true,
      seenAt: serverTimestamp(),
      ...payload, // e.g. { seenBy: userId, role: "employer" }
    },
    { merge: true }
  );
}
